import { ImageProps } from "@lib/image";
import { MDXRemoteSerializeResult } from "next-mdx-remote";
import {
  StrapiConditionDTO,
  ConditionDTO,
} from "@lib/strapi/dtos/content-types/condition.dto";
import { StrapiMediaDTO } from "@lib/strapi/dtos/core/media.dto";
import {
  StrapiPostCategoryDTO,
  PostCategoryDTO,
} from "@lib/strapi/dtos/content-types/postCategory.dto";
import {
  StrapiSEODTO,
  SEODTO,
} from "@lib/strapi/dtos/components/shared/sEO.dto";
import {
  StrapiTeamMemberDTO,
  TeamMemberDTO,
} from "@lib/strapi/dtos/content-types/teamMember.dto";

export class StrapiPostDTO {
  constructor() {}

  title: string;
  slug: string;
  displayDate: Date;
  teaser: string;
  content: string;
  featuredImage: StrapiMediaDTO;
  images: StrapiMediaDTO[];
  author: StrapiTeamMemberDTO;
  categories: StrapiPostCategoryDTO[];
  conditions: StrapiConditionDTO[];
  seo: StrapiSEODTO;
}

export class PostDTO {
  constructor() {}

  extraData: any = {};
  title: string;
  slug: string;
  displayDate: Date;
  teaser: string;
  content: MDXRemoteSerializeResult;
  featuredImage: ImageProps;
  images: ImageProps[];
  author: TeamMemberDTO;
  categories: PostCategoryDTO[];
  conditions: ConditionDTO[];
  seo: SEODTO;
}
